var ClientSubscribeRequest = require('services/control-client/client-subscribe-request');
var TopicSelectorSerialiser = require('topics/topic-selector-serialiser');
var SessionIdSerialiser = require('session/session-id-serialiser');

module.exports = {
    read : function(input) {
        var sessionID = SessionIdSerialiser.read(input);
        var selector = TopicSelectorSerialiser.read(input);

        return new ClientSubscribeRequest(sessionID, selector);
    },
    write : function(output, request) {
        SessionIdSerialiser.write(output, request.sessionID);
        TopicSelectorSerialiser.write(output, request.selector);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control-client/client-subscribe-request-serialiser.js
// module id = 1059
// module chunks = 1